var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#35A1EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9998 29.61C41.9998 28.918 41.9998 28.572 42.1038 28.264C42.4058 27.368 43.2038 27.022 44.0038 26.658C44.8998 26.248 45.3478 26.044 45.7938 26.008C46.2978 25.968 46.8038 26.076 47.2358 26.318C47.8078 26.638 48.2078 27.25 48.6158 27.746C50.5018 30.038 51.4458 31.184 51.7898 32.446C52.0698 33.466 52.0698 34.534 51.7898 35.552C51.2878 37.396 49.6978 38.94 48.5198 40.372C47.9178 41.102 47.6158 41.468 47.2358 41.682C46.7964 41.9257 46.2946 42.0336 45.7938 41.992C45.3478 41.956 44.8998 41.752 44.0018 41.342C43.2018 40.978 42.4058 40.632 42.1038 39.736C41.9998 39.428 41.9998 39.082 41.9998 38.39V29.61ZM21.9998 29.61C21.9998 28.738 21.9758 27.956 21.2718 27.344C21.0158 27.122 20.6758 26.968 19.9978 26.658C19.0998 26.25 18.6518 26.044 18.2058 26.008C16.8718 25.9 16.1538 26.812 15.3858 27.748C13.4978 30.038 12.5538 31.184 12.2078 32.448C11.9294 33.4646 11.9294 34.5374 12.2078 35.554C12.7118 37.396 14.3038 38.942 15.4798 40.372C16.2218 41.272 16.9318 42.094 18.2058 41.992C18.6518 41.956 19.0998 41.752 19.9978 41.342C20.6778 41.034 21.0158 40.878 21.2718 40.656C21.9758 40.044 21.9998 39.262 21.9998 38.392V29.61Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26C18 19.372 24.268 14 32 14C39.732 14 46 19.372 46 26M46 42V43.6C46 47.134 42.42 50 38 50H34",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.4a3ad2b30a89a61378946014b659e325.svg";
export { ForwardRef as ReactComponent };